module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/step6-70af6ebf6520d16d871ab8c40146c30d.svg";